import {buildDashboardPoiApiUrl} from "api/configuration";
import {http} from "../../http";
import {PoiDashboardFilter} from "./fetchPoiDashboardStats";

export const getHeatmapData = (
  filter: PoiDashboardFilter
): Promise<Blob | null> => {
  const {
    territoryCodes,
    carrierIds,
    operatorIds,
    startPeriod,
    endPeriod
  } = filter;
  return http.fetchBlob(
    buildDashboardPoiApiUrl("/poidashboard/heatmap"),
    "Une erreur est survenue lors de la récupération de la heatmap.",
    "post",
    JSON.stringify({
      payload: {
        operatorIds: operatorIds,
        carrierIds: carrierIds,
        startPeriod: startPeriod,
        endPeriod: endPeriod,
        territoryCodes: territoryCodes
      }
    }),
    { Accept: "application/octet-stream", "Content-Type": "application/json" }
  )
};
